"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutonumberFieldLogic = void 0;
const isNil_1 = __importDefault(require("lodash-es/isNil"));
const field_logic_1 = require("../../field-type-registry/field-logic");
const google_sheet_1 = require("../../utils/google-sheet");
const autonumber_1 = require("../../formatters/autonumber");
const autonumber_fieldtype_1 = require("../../safe-field-value/numder-fields/autonumber-field/autonumber.fieldtype");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
const texts_1 = require("../../texts");
const intl_1 = require("../../locale/intl");
class AutonumberFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.aggregates = {
            empty: {
                label: (0, intl_1.$t)(texts_1.aggregatesText.empty),
                aggregator: field_logic_1.countEmpty,
            },
            "non-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.non_empty),
                aggregator: field_logic_1.countFilled,
            },
            "percent-filled": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_filled),
                aggregator: field_logic_1.percentFilled,
            },
            "percent-empty": {
                label: (0, intl_1.$t)(texts_1.aggregatesText.percent_empty),
                aggregator: field_logic_1.percentEmpty,
            },
        };
        this.name = "autonumberfield";
        this.label = (0, intl_1.$t)(texts_1.autoNumberFieldText.auto_number);
        this.icon = "auto-number";
        this.iconColor = "#FF9210";
        this.placeholder = (0, intl_1.$t)(texts_1.autoNumberFieldText.enter_number_here);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.autoNumberFieldText.increment), "id"];
        this.fieldDisabledMessage = (0, intl_1.$t)(texts_1.autoNumberFieldText.this_is_a_system_field);
        this.isCalculated = true;
        this.isNumber = true;
        this.uniqueByApplication = true;
        this.groupByMode = "groupBy";
        this.fieldValueGetter = new autonumber_fieldtype_1.AutonumberFieldValueGetter();
        this.clipboardPasteRules = {};
    }
    get validators() {
        return {};
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editOnStartTyping: false,
            switchToInputControl: "OnCellSelect",
            editorWidth: "100%",
            allowAddRecordToGroup: false,
        };
    }
    valueToString(fieldValue, field, _userPreferences, record) {
        var _a;
        if ((0, isNil_1.default)(fieldValue)) {
            return "";
        }
        return (_a = (0, autonumber_1.formatAutoNumberValue)(fieldValue, field.params, record)) !== null && _a !== void 0 ? _a : "";
    }
    valueToExport(fieldValue, field, preferences, record) {
        return this.valueToString(fieldValue, field, preferences, record);
    }
    valueToGoogleSheet(fieldValue, field, preferences, record) {
        if (field.params.include_labels) {
            return (0, google_sheet_1.makeRowDataValues)(this.valueToString(fieldValue, field, preferences, record), "stringValue");
        }
        return (0, google_sheet_1.makeRowDataValues)(fieldValue, "numberValue");
    }
    processFilterValue(filterValue, comparison) {
        const emptyComparisons = ["is_empty", "is_not_empty"];
        if (typeof filterValue === "number") {
            return filterValue;
        }
        // remove all characters from string except numbers
        return !emptyComparisons.includes(comparison)
            ? +filterValue.replace(/\D+/g, "")
            : filterValue;
    }
    canChangeValue() {
        return false;
    }
    canMoveFieldBeforePrimaryField() {
        return true;
    }
    getCommonFieldParams(field) {
        return { ...super.getCommonFieldParams(field), hidden: false };
    }
    getAppFieldSlug() {
        return "autonumber";
    }
    getDuplicateFieldOptions() {
        return {
            includeContentChecked: false,
            includeContentDisabled: true,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.AutonumberFieldLogic = AutonumberFieldLogic;
